import { createContext } from 'react';

export const EventContext = createContext([
  (_event: any, _cb: any) => {}, // subscribe
  (_event: any, _cb: any) => {}, // unsubscribe
  (_event: any, _payload: any) => {}, // dispatch
]);
